"use client";

import { useState, useEffect, useRef } from 'react';

interface CursorLabelProps {
  text: string;
  isVisible: boolean;
}

export const CursorLabel: React.FC<CursorLabelProps> = ({ text, isVisible }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [labelWidth, setLabelWidth] = useState(0);
  const labelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    if (isVisible) {
      document.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isVisible]);

  useEffect(() => {
    if (labelRef.current && isVisible) {
      setLabelWidth(labelRef.current.offsetWidth);
    }
  }, [text, isVisible]);

  if (!isVisible) return null;

  return (
    <div
      ref={labelRef}
      className="fixed pointer-events-none z-50 bg-foreground text-background px-2 py-1 text-sm rounded transition-opacity duration-200"
      style={{
        left: position.x - (labelWidth / 2), // Center horizontally under cursor
        top: position.y + 15,  // Position below cursor
        opacity: isVisible ? 1 : 0,
      }}
    >
      {text}
    </div>
  );
};
